/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Service from '@ember/service';
import { action } from '@ember/object';
import Evented from '@ember/object/evented';
import { tracked } from '@glimmer/tracking';
import type Conversation from 'embercom/objects/inbox/conversation';
import { EntityType } from 'embercom/models/data/entity-types';
export const PREVIEW_RESTART_EVENT = 'previewRestart';
export const PREVIEW_TAB_CHANGE_EVENT = 'previewTabChange';

export type PreviewTab = 'customer' | 'teammate';

export default class ProcedurePreviewService extends Service.extend(Evented) {
  @tracked conversationId: number | undefined;
  @tracked conversation: Conversation | undefined;
  @tracked selectedTab: PreviewTab = 'customer';
  @tracked procedureId: string | undefined;
  @tracked draftVersionId: string | undefined;

  get hasActiveConversation(): boolean {
    return this.conversationId !== undefined && this.conversation !== undefined;
  }

  get entityType(): number {
    return EntityType.TriggerableCustomBot;
  }

  @action
  togglePreviewTab(): void {
    this.selectedTab = this.selectedTab === 'customer' ? 'teammate' : 'customer';
    this.trigger(PREVIEW_TAB_CHANGE_EVENT, this.selectedTab);
  }

  @action
  restartPreview(): boolean {
    let iframe = window.document.querySelector(
      '#hosted-messenger-unified-preview',
    ) as HTMLIFrameElement;

    let payload = {
      type: 'show-new-conversation',
    };

    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(JSON.stringify(payload));
      this.trigger(PREVIEW_RESTART_EVENT);
      return true;
    }

    return false;
  }

  @action
  setProcedureData(procedureId: string, draftVersionId: string): void {
    this.procedureId = procedureId;
    this.draftVersionId = draftVersionId;
  }

  @action
  clearProcedureData(): void {
    this.procedureId = undefined;
    this.draftVersionId = undefined;
  }
}

declare module '@ember/service' {
  interface Registry {
    ProcedurePreviewService: ProcedurePreviewService;
    'procedure-preview-service': ProcedurePreviewService;
  }
}
